/*
* @requires  fileseal-websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function FileSeal(param) {
        this.context=param.context;
        this.imp=new $m.FileSealWebsocket(param,this,null);
        //this.imp.setEventCallback(this,null);
        this.seal=null;
        this.middleware=null;
    }

    FileSeal.prototype._getSeal=function (param){
        if(this.seal){
            param.success(this.seal)
        }else{
            this.seal=new $m.Seal(param)
        }
    };

    FileSeal.prototype._getMiddleware=function (param){
        if(this.middleware){
            param.success(this.middleware)
        }else{
            this.middleware=new $m.Middleware(param)
        }
    };

    FileSeal.prototype._assertCertLogined=function (param){
        var seq=new $m.Seq();
        var that=this;
        var middleware=null;
        seq.then(function (){
            that._getMiddleware({
                success: function (m){
                    middleware=m;
                    seq.resolve(m);
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (){
            if(!param.command.sign.certSubjectId){
                middleware.selectCert({
                    success:function (cert){
                        param.command.sign.certSubjectId=cert.certId;
                        param.command.sign.cert=cert.cert;
                        seq.resolve(cert);
                    },
                    fail:function (e){
                        seq.reject(e);
                    }
                })
            }else{
                middleware.getCerts({
                    certType:"sign",
                    success:function (certs){
                        for(var i=0;i<certs.length;i++){
                            if(certs[i].certId === param.command.sign.certSubjectId){
                                seq.resolve(certs[i])
                                return
                            }
                        }

                        seq.reject(new Error("找不到对应的证书"))
                    },
                    fail:function (e){
                        seq.reject(e);
                    }
                })
            }
        }).then(function (seq,cert){
            middleware.login({
                sn: cert.sn,
                password: param.password,
                success:function (){
                    seq.resolve();
                },
                fail:function (e){
                    seq.reject(e);
                }
            })
        }).then(function (){
            $m.util.success(param,param.command.sign.certSubjectId);
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype._assertSealLogined=function (param){
        var seq=new $m.Seq();
        var that=this;
        var seal=null;
        seq.then(function (){
            that._getSeal({
                context: param.context,
                success: function (s){
                    seal=s;
                    seq.resolve(s);
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (){
            if(!param.command.sealSn){
                seal.selectSeal({
                    success:function (s){
                        param.command.sealSn=s.sealSn;
                        seq.resolve();
                    },
                    fail:function (e){
                        seq.reject(e);
                    }
                })
            }else{
                seq.resolve()
            }
        }).then(function (){
            seal.loginSeal({
                sealSn: param.command.sealSn,
                password: param.password,
                success:function (){
                    seq.resolve();
                },
                fail:function (e){
                    seq.reject(e);
                }
            })
        }).then(function (){
            $m.util.success(param,param.command.sealSn);
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype._assertSealSelected=function (param){
        var seq=new $m.Seq();
        var that=this;
        var seal=null;
        seq.then(function (){
            that._getSeal({
                context: param.context,
                success: function (s){
                    seal=s;
                    seq.resolve(s);
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (){
            if(!param.command.sealSn){
                seal.selectSeal({
                    success:function (s){
                        param.command.sealSn=s.sealSn;
                        seq.resolve();
                    },
                    fail:function (e){
                        seq.reject(e);
                    }
                })
            }else{
                seq.resolve()
            }
        }).then(function (){
            $m.util.success(param,param.command.sealSn);
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype._writeTempFile=function (param){
        var seq=new $m.Seq();
        var that=this;
        var middleware=null;
        seq.then(function (){
            that._getMiddleware({
                success: function (m){
                    middleware=m;
                    seq.resolve(m);
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (seq){
            //写入一个临时文件，作为输入
            middleware.writeFile({
                data: param.inData,
                dataFormat: "Base64",
                newFilePattern: "sign-*."+param.fileType,
                success: function (tempFile){
                    seq.resolve(tempFile)
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (seq,tempFile){
            //生成一个临时文件作为输出
            middleware.getFilePath({
                name: "TEMP",
                newFilePattern: "sign-*."+param.fileType,
                success: function (outFile){
                    seq.resolve({
                        inFile: tempFile,
                        outFile: outFile
                    })
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (seq,ret){
            $m.util.success(param,ret);
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype._writeTempFileOnlyInData=function (param){
        var seq=new $m.Seq();
        var that=this;
        var middleware=null;
        seq.then(function (){
            that._getMiddleware({
                success: function (m){
                    middleware=m;
                    seq.resolve(m);
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (seq){
            //写入一个临时文件，作为输入
            middleware.writeFile({
                data: param.inData,
                dataFormat: "Base64",
                newFilePattern: "sign-*."+param.fileType,
                success: function (tempFile){
                    seq.resolve(tempFile)
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (seq,tempFile){
            $m.util.success(param,tempFile);
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype._readTempFile=function (param){
        var seq=new $m.Seq();
        var that=this;
        var middleware=null;
        seq.then(function (){
            that._getMiddleware({
                success: function (m){
                    middleware=m;
                    seq.resolve(m);
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (seq){
            middleware.readFile({
                file: param.outFile,
                dataFormat: "Base64",
                success: function (data){
                    seq.resolve(data)
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (seq,data){
            //删除临时文件，不用等待完成
            if(param.inFile){
                middleware.removeFile({
                    fileName: param.inFile,
                })
            }
            middleware.removeFile({
                fileName: param.outFile,
            })
            seq.resolve(data)
        }).then(function (seq,data){
            $m.util.success(param,data);
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    }

    FileSeal.prototype._removeTempFile=function (param){
        var seq=new $m.Seq();
        var that=this;
        var middleware=null;
        seq.then(function (){
            that._getMiddleware({
                success: function (m){
                    middleware=m;
                    seq.resolve(m);
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (seq){
            //删除临时文件，不用等待完成
            middleware.removeFile({
                fileName: param.file,
            })
            seq.resolve()
        }).then(function (seq){
            $m.util.success(param,null);
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    }

    FileSeal.prototype._getOutputTempFile=function (param){
        var seq=new $m.Seq();
        var that=this;
        var middleware=null;
        seq.then(function (){
            that._getMiddleware({
                success: function (m){
                    middleware=m;
                    seq.resolve(m);
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (seq){
            //生成一个临时文件作为输出
            middleware.getFilePath({
                name: "TEMP",
                newFilePattern: "sign-*."+param.fileType,
                success: function (outFile){
                    seq.resolve(outFile)
                },
                fail: function (e){
                    seq.reject(e);
                }
            })
        }).then(function (seq,outFile){
            $m.util.success(param,outFile);
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype.signOfd=function (param) {
        var seq=new $m.Seq();
        var that=this;
        seq.then(function (){
            if(!param.multiSeal){
                if(param.command.sealType===0){
                    //签章
                    if(that.context.substr(that.context.length-3)==="oes"){
                        that._assertSealSelected({
                            context: that.context,
                            command: param.command,
                            success:function (sealSn){
                                param.command.sealSn=sealSn;
                                seq.resolve();
                            },
                            fail:function (e){
                                seq.reject(e);
                            }
                        })
                    } else {
                        that._assertSealLogined({
                            context: that.context,
                            command: param.command,
                            password: param.password,
                            success:function (sealSn){
                                param.command.sealSn=sealSn;
                                seq.resolve();
                            },
                            fail:function (e){
                                seq.reject(e);
                            }
                        })
                    }
                }
                else {
                    //签批
                    if(!param.command.sign){
                        seq.reject(new Error("缺少签批参数，sign对象为空"))
                        return
                    }
                    that._assertCertLogined({
                        command: param.command,
                        password: param.password,
                        success:function (certId){
                            param.command.sign.certSubjectId=certId;
                            seq.resolve();
                        },
                        fail:function (e){
                            seq.reject(e);
                        }
                    })
                }
            }else{
                seq.resolve()
            }
        }).then(function (){
            if(param.inData){
                //字符串输入
                that._writeTempFile({
                    inData: param.inData,
                    fileType: "ofd",
                    success: function (ret){
                        param.inFile=ret.inFile
                        param.outFile=ret.outFile
                        seq.resolve()
                    },
                    fail: function (e){
                        seq.reject(e)
                    }
                })
            } else {
                seq.resolve()
            }
        }).then(function (){
            param.command=JSON.stringify(param.command);
            var p={
                success: function (){
                    seq.resolve()
                },
                fail: function (e){
                    seq.reject(e)
                }
            };
            $m.util.setAttrs(p,param,["command", "multiSeal", "password", "inFile", "outFile", "inUrl", "outUrl",
                "partName", "fileName", "certVerify", "sealVerify", "enableTimeStamp"])
            that.imp.signOfd(p);
        }).then(function (){
            if(param.inData){
                that._readTempFile({
                    outFile: param.outFile,
                    inFile: param.inFile,
                    success: function (d){
                        $m.util.success(param,d);
                    },
                    fail: function (e){
                        $m.util.fail(param,e);
                    }
                })
            } else {
                $m.util.success(param,null);
            }
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype.hashOfd=function (param) {

        var seq=new $m.Seq();
        var that=this;
        seq.then(function (){
            if(param.inData){
                //字符串输入
                that._writeTempFileOnlyInData({
                    inData: param.inData,
                    fileType: "ofd",
                    success: function (inFile){
                        param.inFile=inFile
                        seq.resolve()
                    },
                    fail: function (e){
                        seq.reject(e)
                    }
                })
            } else {
                seq.resolve()
            }
        }).then(function (){
            param.command=JSON.stringify(param.command);
            var p={
                success: function (data){
                    seq.resolve(data)
                },
                fail: function (e){
                    seq.reject(e)
                }
            };
            $m.util.setAttrs(p,param,["command", "inFile",  "inUrl", "enableTimeStamp"])
            that.imp.hashOfd(p);
        }).then(function (seq,data){
            if(param.inData){
                that._removeTempFile({
                    file: param.inFile,
                    success: function (){
                        $m.util.success(param,data);
                    },
                    fail: function (e){
                        $m.util.fail(param,e);
                    }
                })
            } else {
                $m.util.success(param,data);
            }
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype.hashOfdNext=function (param) {
        param.command=JSON.stringify(param.command);
        this.imp.hashOfdNext(param);
    };

    FileSeal.prototype.mergeOfd=function (param) {
        var seq=new $m.Seq();
        var that=this;
        seq.then(function (){
            if(!param.outFile && !param.outUrl){
                //以字符串返回
                that._getOutputTempFile({
                    fileType:"ofd",
                    success: function (outFile){
                        param.outFile=outFile
                        param.outStr=true
                        seq.resolve()
                    },
                    fail: function (e){
                        seq.reject(e)
                    }
                })
            } else {
                seq.resolve()
            }
        }).then(function (){
            var p={
                success: function (){
                    seq.resolve()
                },
                fail: function (e){
                    seq.reject(e)
                }
            };
            $m.util.setAttrs(p,param,["signature","dataHash","outFile","outUrl","partName","fileName","certVerify","enableTimeStamp"])
            that.imp.mergeOfd(p);
        }).then(function (){
            if(param.outStr){
                that._readTempFile({
                    outFile: param.outFile,
                    success: function (d){
                        $m.util.success(param,d);
                    },
                    fail: function (e){
                        $m.util.fail(param,e);
                    }
                })
            } else {
                $m.util.success(param,null);
            }
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype.verifyOfd=function (param) {

        var seq=new $m.Seq();
        var that=this;
        seq.then(function (){
            if(param.inData){
                //字符串输入
                that._writeTempFileOnlyInData({
                    inData: param.inData,
                    fileType: "ofd",
                    success: function (inFile){
                        param.inFile=inFile
                        seq.resolve()
                    },
                    fail: function (e){
                        seq.reject(e)
                    }
                })
            } else {
                seq.resolve()
            }
        }).then(function (){
            param.command=JSON.stringify(param.command);
            var p={
                success: function (data){
                    seq.resolve(data)
                },
                fail: function (e){
                    seq.reject(e)
                }
            };
            $m.util.setAttrs(p,param,["inFile","inUrl","certVerify","sealVerify","detail"])
            that.imp.verifyOfd(p);
        }).then(function (seq,data){
            if(param.inData){
                that._removeTempFile({
                    file: param.inFile,
                    success: function (){
                        $m.util.success(param,data);
                    },
                    fail: function (e){
                        $m.util.fail(param,e);
                    }
                })
            } else {
                $m.util.success(param,data);
            }
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype.signPdf=function (param) {
        var seq=new $m.Seq();
        var that=this;
        seq.then(function (){
            if(!param.multiSeal && !param.extSealConfig){
                if(param.command.sealType===0){
                    //签章
                    that._assertSealLogined({
                        context: that.context,
                        command: param.command,
                        password: param.password,
                        success:function (sealSn){
                            param.command.sealSn=sealSn;
                            seq.resolve();
                        },
                        fail:function (e){
                            seq.reject(e);
                        }
                    })
                }else{
                    //签批：文字签批、图片签批
                    if(!param.command.sign){
                        seq.reject(new Error("缺少签批参数，sign对象为空"))
                        return
                    }
                    that._assertCertLogined({
                        command: param.command,
                        password: param.password,
                        success:function (certId){
                            param.command.sign.certSubjectId=certId;
                            seq.resolve();
                        },
                        fail:function (e){
                            seq.reject(e);
                        }
                    })
                }
            }else{
                seq.resolve()
            }
        }).then(function (){
            if(param.inData){
                //字符串输入
                that._writeTempFile({
                    inData: param.inData,
                    fileType: "pdf",
                    success: function (ret){
                        param.inFile=ret.inFile
                        param.outFile=ret.outFile
                        seq.resolve()
                    },
                    fail: function (e){
                        seq.reject(e)
                    }
                })
            } else {
                seq.resolve()
            }
        }).then(function (){
            param.command=JSON.stringify(param.command);
            var p={
                success: function (){
                    seq.resolve()
                },
                fail: function (e){
                    seq.reject(e)
                }
            };
            $m.util.setAttrs(p,param,["command", "multiSeal", "password", "inFile", "outFile", "inUrl", "outUrl",
                "partName", "fileName", "certVerify", "sealVerify", "enableTimeStamp","extSealConfig"])
            that.imp.signPdf(p);
        }).then(function (){
            if(param.inData){
                that._readTempFile({
                    outFile: param.outFile,
                    inFile: param.inFile,
                    success: function (d){
                        $m.util.success(param,d);
                    },
                    fail: function (e){
                        $m.util.fail(param,e);
                    }
                })
            } else {
                $m.util.success(param,null);
            }
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype.hashPdf=function (param) {
        var seq=new $m.Seq();
        var that=this;
        seq.then(function (){
            if(param.inData){
                //字符串输入
                that._writeTempFileOnlyInData({
                    inData: param.inData,
                    fileType: "pdf",
                    success: function (inFile){
                        param.inFile=inFile
                        seq.resolve()
                    },
                    fail: function (e){
                        seq.reject(e)
                    }
                })
            } else {
                seq.resolve()
            }
        }).then(function (){
            param.command=JSON.stringify(param.command);
            var p={
                success: function (data){
                    seq.resolve(data)
                },
                fail: function (e){
                    seq.reject(e)
                }
            };
            $m.util.setAttrs(p,param,["command", "inFile",  "inUrl", "enableTimeStamp"])
            that.imp.hashPdf(p);
        }).then(function (seq,data){
            if(param.inData){
                that._removeTempFile({
                    file: param.inFile,
                    success: function (){
                        $m.util.success(param,data);
                    },
                    fail: function (e){
                        $m.util.fail(param,e);
                    }
                })
            } else {
                $m.util.success(param,data);
            }
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();

    };

    FileSeal.prototype.hashPdfNext=function (param) {
        param.command=JSON.stringify(param.command);
        this.imp.hashPdfNext(param);
    };

    FileSeal.prototype.mergePdf=function (param) {
        var seq=new $m.Seq();
        var that=this;
        seq.then(function (){
            if(!param.outFile && !param.outUrl){
                //以字符串返回
                that._getOutputTempFile({
                    fileType:"pdf",
                    success: function (outFile){
                        param.outFile=outFile
                        param.outStr=true
                        seq.resolve()
                    },
                    fail: function (e){
                        seq.reject(e)
                    }
                })
            } else {
                seq.resolve()
            }
        }).then(function (){
            param.command=JSON.stringify(param.command);
            var p={
                success: function (){
                    seq.resolve()
                },
                fail: function (e){
                    seq.reject(e)
                }
            };
            $m.util.setAttrs(p,param,["signature","outFile", "outUrl", "partName", "fileName", "enableTimeStamp"])
            that.imp.mergePdf(p);
        }).then(function (){
            if(param.outStr){
                that._readTempFile({
                    outFile: param.outFile,
                    success: function (d){
                        $m.util.success(param,d);
                    },
                    fail: function (e){
                        $m.util.fail(param,e);
                    }
                })
            } else {
                $m.util.success(param,null);
            }
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype.verifyPdf=function (param) {
        var seq=new $m.Seq();
        var that=this;
        seq.then(function (){
            if(param.inData){
                //字符串输入
                that._writeTempFileOnlyInData({
                    inData: param.inData,
                    fileType: "pdf",
                    success: function (inFile){
                        param.inFile=inFile
                        seq.resolve()
                    },
                    fail: function (e){
                        seq.reject(e)
                    }
                })
            } else {
                seq.resolve()
            }
        }).then(function (){
            param.command=JSON.stringify(param.command);
            var p={
                success: function (data){
                    seq.resolve(data)
                },
                fail: function (e){
                    seq.reject(e)
                }
            };
            $m.util.setAttrs(p,param,["inFile","inUrl","certVerify","sealVerify","detail"])
            that.imp.verifyPdf(p);
        }).then(function (seq,data){
            if(param.inData){
                that._removeTempFile({
                    file: param.inFile,
                    success: function (){
                        $m.util.success(param,data);
                    },
                    fail: function (e){
                        $m.util.fail(param,e);
                    }
                })
            } else {
                $m.util.success(param,data);
            }
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    FileSeal.prototype.ofd2pdf=function (param) {
        this.imp.ofd2pdf(param);
    };

    FileSeal.prototype.pdf2ofd=function (param) {
        this.imp.pdf2ofd(param);
    };

    FileSeal.prototype.openOfd=function (param) {
        this.imp.openOfd(param);
    };

    FileSeal.prototype.closeOfd=function (param) {
        this.imp.closeOfd(param);
    };

    FileSeal.prototype.getOfdInfo=function (param) {
        this.imp.getOfdInfo(param);
    };

    FileSeal.prototype.saveOfd=function (param) {
        this.imp.saveOfd(param);
    };

    FileSeal.prototype.ofdRenderPage=function (param) {
        this.imp.ofdRenderPage(param);
    };

    FileSeal.prototype.getOfdPageInfo=function (param) {
        this.imp.getOfdPageInfo(param);
    };

    FileSeal.prototype.close=function () {
        this.imp.close();
    };


    $m.FileSeal=FileSeal;

})(HebcaMiddleware);
